import { render, staticRenderFns } from "./CoursesManagementComponent.vue?vue&type=template&id=7e319bea&scoped=true&"
import script from "./CoursesManagementComponent.vue?vue&type=script&lang=js&"
export * from "./CoursesManagementComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoursesManagementComponent.vue?vue&type=style&index=0&id=7e319bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e319bea",
  null
  
)

export default component.exports